const AppleIdRoutes = [
    {
        path: '/shared-apple-id',
        name: 'ChatGPTAppleId',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
     {
        path: '/en/shared-apple-id',
        name: 'ChatGPTAppleIdEN',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/shared-apple-id-cn',
        name: 'ChatGPTAppleIdCN',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/cn/shared-apple-id',
        name: 'ChatGPTAppleIdCN',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/es/shared-apple-id',
        name: 'ChatGPTAppleIdES',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/de/shared-apple-id',
        name: 'ChatGPTAppleIdDE',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/fr/shared-apple-id',
        name: 'ChatGPTAppleIdFR',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/ko/shared-apple-id',
        name: 'ChatGPTAppleIdKO',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/ru/shared-apple-id',
        name: 'ChatGPTAppleIdRU',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/jp/shared-apple-id',
        name: 'ChatGPTAppleIdJP',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/br/shared-apple-id',
        name: 'ChatGPTAppleIdBR',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    },
    {
        path: '/it/shared-apple-id',
        name: 'ChatGPTAppleIdIT',
        component: () => import(/* webpackChunkName: "chatgptAppleId" */'@/views/3-in-1/chatgpt/ChatGPTAppleId.vue')
    }
]


export default AppleIdRoutes;


